module.exports = __webpack_public_path__ + "static/media/sekira.65d372e3.jpg";